'use client';

import { useAppNotification } from '@bts-web/core-features/notifications';
import { translateGqlErrorCodesOrReturnThemDirectly } from './translateGqlErrorCodesOrReturnThemDirectly';
import { isDevelopmentEnv } from '@bts-web/utils-functions';

// Enhanced caller detection
const getCallerInfo = () => {
  const stack = new Error().stack;

  if (!stack) return 'unknown';

  const lines = stack.split('\n');

  for (let i = 3; i < lines.length; i++) {
    const line = lines[i];

    if (
      line.includes('.tsx') ||
      line.includes('.ts') ||
      line.includes('.jsx') ||
      line.includes('.js')
    ) {
      const match = line.match(/\/([^/]+\.(?:tsx?|jsx?)):/);

      if (match) return match[1];
    }
  }

  return 'unknown';
};

export const useHandleGqlErrorsWithSnackbar = () => {
  const { setAppNotification } = useAppNotification();

  const processErrors = async (gqlResponseErrors?: string[]) => {
    if (isDevelopmentEnv()) {
      const callerFile = getCallerInfo();

      console.warn('processErrors called from file:', callerFile);

      console.warn('processErrors generated the errors ', gqlResponseErrors);
    }

    const { genericTitle, translatedCodes } =
      await translateGqlErrorCodesOrReturnThemDirectly(gqlResponseErrors);

    setAppNotification({
      visual: 'error',
      title: genericTitle,
      subtitle: translatedCodes.join('\n'),
    });
  };

  return { processErrors };
};
